import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../_models/file-info-display-result-dto';

export class WFReimbursementRequestLineItemsResultDto {
    reimbursementWorkflowId: number;
    lineItemWorkflowId: number;

    @Type(() => Date)
    transactionDate: Date;

    @Type(() => FileInfoDisplayResultDto)
    invoiceFileInfo: FileInfoDisplayResultDto;

    description: string;
    amount: number;
    invoiceNumber: string;
    glAccountNumber: string;
    glAccount: string;
    subCategory: string;
    dimensions: string;
    isReimbursable: boolean;

    allowAttachReceipt: boolean;
    allowReclassify: boolean;
    allowToggleReimbursable: boolean;
    allowSelection: boolean;

    apBillId: number;
}
